import { render } from "./education.vue?vue&type=template&id=3ec1fc03&scoped=true"
import script from "./education.vue?vue&type=script&lang=js"
export * from "./education.vue?vue&type=script&lang=js"

import "./education.vue?vue&type=style&index=0&id=3ec1fc03&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec1fc03"]])

export default __exports__